<div class="side-sheet" [ngClass]="{'active': selectedReviewId}">
  <div class="d-flex h-100">

      <div class="overlay" (click)="close.emit()"></div>

      <div class="sheet-container">
          <div class="sheet-head">
              <div class="title">{{'content3.Review Details' | translate}}</div>

              <button type="button" mat-icon-button (click)="close.emit()">
                  <img src="./assets/images/icons/close.svg" alt="">
              </button>
          </div>
          <div *ngIf='dataLoading' class="dataLoading">
              <mat-spinner class="m-auto" diameter="50"></mat-spinner>
          </div>

          <ng-container *ngIf="!dataLoading && review">

              <div class="sheet-content p-0">
                  <div class="review-details">
                      <div class="user-details-card">
                          <div class="d-flex mb-3">
                              <div class="name-with-image">
                                  <div class="image-circle">
                                      <span *ngIf="!review.reviewIcon">{{ review.reviewName | shortName }}</span>
                                      <img *ngIf="review.reviewIcon" [src]="review.reviewIcon"
                                          (error)="review.reviewIcon = ''">
                                  </div>
                                  <div class="name">
                                      <p class="font-16 fontMedium text-color">{{review.reviewName}}</p>
                                  </div>
                              </div>
                              <div class="info-with-background ml-auto" *ngIf="review.isPostedanonymously">
                                  <p class="info font-14 fontMedium dark-grey-color">
                                      {{'content3.Posted anonymously' | translate}}
                                  </p>
                              </div>

                          </div>
                          <hr>
                          <p class="font-14 fontRegular grey-color">{{'content3.Posted on' | translate}}</p>
                          <p class="font-16 fontMedium text-color">
                              {{review.reviewDate | date:'d MMM, y'}} {{'guests.at' | translate }} {{review.reviewDate | date:'shortTime'}}
                          </p>

                          <!-- If Guests Reviews Component -->
                          <ng-container *ngIf="isGuestsReview || isReported">
                              <hr class="mt-3">
                              <div class="d-flex align-items-center justify-content-between">
                                <div class="name-with-image">
                                    <div class="image-circle no-border">
                                        <span *ngIf="!review.brancheIcon">{{ review.brancheName | shortName }}</span>
                                        <img *ngIf="review.brancheIcon" [src]="review.brancheIcon"
                                            (error)="review.brancheIcon = ''">
                                    </div>
                                    <div class="name">
                                        <p class="font-14 fontMedium text-color">{{review.brancheNameEn}}</p>
                                        <p class="font-14 fontBold text-color">{{review.brancheNameAr}}</p>
                                    </div>
                                </div>

                                <div>
                                  <ng-container *ngIf="isGuestsReview">
                                    <!-- If review is Reported -->
                                    <span class="status-badge red" *ngIf="review.reportStatus == 'Reported'">
                                        {{'reviews.Reported' | translate}}
                                    </span>
                                    <!-- If review is Resolved -->
                                    <span class="status-badge green" *ngIf="review.reportStatus == 'Resolved'">
                                        {{'reviews.Resolved' | translate}}
                                    </span>
                                  </ng-container>
                                  <ng-container *ngIf="review.reportDecision">
                                    <!-- If review is Kept -->
                                    <span class="status-badge ml-2" *ngIf="review.reportDecision[0]?.decisionType == 'Keep'">
                                        {{review.reportDecision[0].resolution}}
                                    </span>
                                    <!-- If review is Hidden -->
                                    <span class="status-badge orange ml-2" *ngIf="review.isHide">
                                        {{'reviews.Hidden' | translate}}
                                    </span>
                                  </ng-container>
                                </div>
                              </div>
                          </ng-container>
                      </div>

                      <div class="reservation d-flex">
                          <span class="font-14 fontRegular grey-color">
                              {{'content3.Reservation' | translate}} #:
                              <span class="font-16 fontMedium text-color">
                                  {{ review.reservationNumber }}
                              </span>
                          </span>
                          <!-- <div class="ml-auto font-14 fontRegular grey-color">
                        <button type="button" mat-icon-button class="flat-btn">
                          <span>{{'general.View' | translate}}</span>
                          <img src="./assets/images/icons/open_in_new_black_24dp.svg">
                        </button>
                      </div> -->
                          <!-- <span class="ml-auto font-14 fontRegular grey-color d-flex align-items-center">
                              {{'general.View' | translate}}
                              <img src="./assets/images/icons/open_in_new_black_24dp.svg">
                          </span> -->
                      </div>

                      <div class="rating">
                          <div class="rate-item d-flex">
                              <span class="font-16 fontRegular text-color">
                                  {{'content3.Overall rating of the restaurant' | translate}}
                              </span>

                              <div class="ml-auto">
                                <ng-container *ngIf="review.reviewRate; else skipped">
                                  <img src="./assets/images/icons/stars.svg" alt="">
                                  <span class="font-16 fontRegular text-color mt-1 ml-2">
                                      {{review.reviewRate}}
                                  </span>
                                </ng-container>
                                <ng-template #skipped>{{ 'reviews.skipped' | translate }}</ng-template>
                              </div>
                          </div>

                      </div>
                  </div>

                  <ng-container *ngIf="review.orderedItems?.length">
                      <div class="heads">
                          <p>{{'content3.Ordered Items' | translate}}</p>
                      </div>
                      <div class="rating-list">
                          <div class="rate-item d-flex" *ngFor="let order of review.orderedItems">
                              <div class="img-card">
                                  <span *ngIf="!order.orederItemIcon">{{ order.orderItemName | shortName }}</span>
                                  <img *ngIf="order.orederItemIcon" [src]="order.orederItemIcon"
                                      (error)="order.orederItemIcon = ''">
                              </div>
                              <span class="font-14 fontMedium text-color ml-2">{{order.orderItemName}}</span>
                              <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                              <span class="font-15 fontMedium text-color ml-2">
                                  {{order.orderItemRate}}
                              </span>
                          </div>
                          <!-- <div class="rate-item d-flex">
                        <div class="img-card">
                            <img src="./assets/images/icons/item photo.svg">
                        </div>
                        <span class="font-14 fontMedium text-color ml-2">Awadhi Murg Korma</span>
                        <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                        <span class="font-15 fontMedium text-color ml-2">4.0</span>
                    </div>
                    <div class="rate-item d-flex">
                        <div class="img-card">
                            <img src="./assets/images/icons/item photo.svg">
                        </div>
                        <span class="font-14 fontMedium text-color ml-2">Awadhi Murg Korma</span>
                        <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                        <span class="font-15 fontMedium text-color ml-2">4.0</span>
                    </div>
                    <div class="rate-item d-flex">
                        <div class="img-card">
                            <img src="./assets/images/icons/item photo.svg">
                        </div>
                        <span class="font-14 fontMedium text-color ml-2">Awadhi Murg Korma</span>
                        <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                        <span class="font-15 fontMedium text-color ml-2">4.0</span>
                    </div>
                    <div class="rate-item d-flex">
                        <div class="img-card">
                            <img src="./assets/images/icons/item photo.svg">
                        </div>
                        <span class="font-14 fontMedium text-color ml-2">Awadhi Murg Korma</span>
                        <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                        <span class="font-15 fontMedium text-color ml-2">4.0</span>
                    </div> -->
                      </div>
                  </ng-container>


                  <ng-container *ngIf="review.amenities?.length">
                      <div class="heads">
                          <p>{{'content5.Amenities' | translate}}</p>
                      </div>
                      <!-- <ngb-rating [max]="5" [(rate)]="rate" [readonly]="true" [starTemplate]="line" class="line-rating">
                    <ng-template #line let-fill="fill">
                        <i class="line" [ngClass]="{'line-o yellow' : fill > 0 , 'line' : fill == 0}">
                            <i class="line-o filled" [style.width.%]="fill"
                                [ngClass]="{'line-o' : fill == 0 , 'line' : fill > 0}"></i>
                        </i>
                    </ng-template>
                </ngb-rating> -->

                      <div class="rating-list">
                          <div class="rate-item d-flex" *ngFor="let amenity of review.amenities">
                              <ng-container *ngIf="amenity.amenitiesRateType == 'StarRating'">
                                  <div class="img-card">
                                      <span *ngIf="!amenity.amenitiesIcon" class="d-block m-auto pt-0">{{
                                          amenity.amenitiesName | shortName }}</span>
                                      <img *ngIf="amenity.amenitiesIcon" [src]="amenity.amenitiesIcon"
                                          (error)="amenity.amenitiesIcon = ''">
                                      <!-- <img [src]="amenity.amenitiesIcon"> -->
                                  </div>
                                  <span class="font-14 fontMedium text-color ml-2">{{amenity.amenitiesName}}</span>
                                  <ng-container *ngIf="amenity.amenitiesRate != 0; else skipped">
                                      <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                                      <span class="font-15 fontMedium text-color ml-2">{{amenity.amenitiesRate}}</span>
                                    </ng-container>
                                    <ng-template #skipped>
                                      <p class="ml-auto d-flex align-items-center">{{ 'reviews.skipped' | translate }}</p>
                                    </ng-template>
                              </ng-container>
                              <ng-container *ngIf="amenity.amenitiesRateType == 'DashRating'">
                                  <div class="img-card">
                                      <img [src]="amenity.amenitiesIcon">
                                  </div>
                                  <span class="font-14 fontMedium text-color ml-2">{{amenity.amenitiesName}}</span>
                                  <ng-container *ngIf="amenity.amenitiesRate != 0; else skipped">
                                      <ngb-rating [max]="5" [(rate)]="amenity.amenitiesRate" [readonly]="true" [starTemplate]="line"
                                      class="line-rating ml-auto">
                                      <ng-template #line let-fill="fill">
                                        <i class="line" [ngClass]="{'line-o yellow' : fill > 0 , 'line' : fill == 0}">
                                          <i class="line-o filled" [style.width.%]="fill"
                                            [ngClass]="{'line-o' : fill == 0 , 'line' : fill > 0}"></i>
                                        </i>
                                      </ng-template>
                                    </ngb-rating>
                                    <span class="font-15 fontMedium text-color ml-2 mt-2">{{amenity.amenitiesRate}}</span>
                                    </ng-container>
                                    <ng-template #skipped>
                                      <p class="ml-auto d-flex align-items-center">{{ 'reviews.skipped' | translate }}</p>
                                    </ng-template>
                              </ng-container>
                          </div>
                          <!-- <div class="rate-item d-flex">
                        <div class="img-card">
                            <img src="./assets/images/icons/comfort-ic.svg">
                        </div>
                        <span class="font-14 fontMedium text-color ml-2">Comfort</span>
                        <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                        <span class="font-15 fontMedium text-color ml-2">4.0</span>
                    </div>
                    <div class="rate-item d-flex">
                        <div class="img-card">
                            <img src="./assets/images/icons/comfort-ic.svg">
                        </div>
                        <span class="font-14 fontMedium text-color ml-2">Comfort</span>
                        <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                        <span class="font-15 fontMedium text-color ml-2">4.0</span>
                    </div>
                    <div class="rate-item d-flex">
                        <div class="img-card">
                            <img src="./assets/images/icons/comfort-ic.svg">
                        </div>
                        <span class="font-14 fontMedium text-color ml-2">Comfort</span>
                        <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                        <span class="font-15 fontMedium text-color ml-2">4.0</span>
                    </div> -->
                      </div>
                  </ng-container>

                  <div class="heads pt-1 pb-1"></div>

                  <div class="library-list">
                      <p class="font-16 fontRegular">{{review.reviewComment}}</p>

                      <lightgallery class="lightgallery d-block m-auto" [settings]="settings">
                          <div class="gallery-item" *ngFor="let item of review?.reviewPhotos">
                              <a class="view-btn" [href]="item">
                                  <img class="img-responsive d-block m-auto" [src]="item" />
                              </a>
                          </div>
                          <div class="gallery-item" *ngFor="let item of review?.reviewVideos">
                              <a class="video-container view-btn" attr.data-video="{{item}}">
                                  <video [src]="item"></video>
                              </a>
                          </div>
                      </lightgallery>
                  </div>

                  <div class="card-yellow mt-4" *ngIf="review.reportDecision">
                    <div class="card-head">{{'reviews.Resolution' | translate}}</div>
                    <div class="card-content">

                      <div>
                        <p class="font-14 grey-color">{{'reviews.Resolved by' | translate}}</p>
                        <div class="name-with-image thumb">
                          <div class="image-circle mr-2">
                            <span *ngIf="!review.reportDecision[0].resolvedbyIcon">{{ review.reportDecision[0].resolvedbyName | shortName }}</span>
                            <img *ngIf="review.reportDecision[0].resolvedbyIcon" [src]="review.reportDecision[0].resolvedbyIcon" (error)="review.reportDecision[0].resolvedbyIcon = ''">
                          </div>
                          <div class="name">
                            <p class="font-16 fontMedium text-color">{{review.reportDecision[0].resolvedbyName}}</p>
                          </div>
                        </div>
                      </div>

                      <hr>

                      <div>
                        <p class="font-14 grey-color">{{'reviews.Resolution' | translate}}</p>
                        <p class="font-16 fontMedium text-color">{{review.reportDecision[0].resolution}}</p>
                      </div>

                      <hr>

                      <div>
                        <p class="font-14 grey-color">{{'reviews.Resolved on' | translate}}</p>
                        <p class="font-16 fontMedium text-color">
                          <!-- {{review.reportDecision[0].resolvedDate | date}} -->
                          {{review.reportDecision[0].resolvedDate | date:'d MMM, y'}} {{'guests.at' | translate }} {{review.reportDecision[0].resolvedDate | date:'shortTime'}}
                        </p>
                      </div>

                      <hr>

                      <div>
                        <p class="font-14 grey-color">{{'forms.Notes' | translate}}</p>
                        <p class="font-16 fontMedium text-color">{{review.reportDecision[0].resolutionComment}}</p>
                      </div>

                      <div class="d-flex ml-auto justify-content-end mt-3" *ngIf="review.reportDecision.length > 1">
                        <button class="btn dropdown-custom" (click)="showHistory = !showHistory">
                          <span class="pr-2">
                            <ng-container *ngIf="!showHistory">
                              {{"reportedContent.Show History" | translate}}
                            </ng-container>
                            <ng-container *ngIf="showHistory">
                              {{"reportedContent.Hide History" | translate}}
                            </ng-container>
                          </span>
                        </button>
                      </div>

                      <!-- HISTORY -->
                      <ng-container *ngIf="showHistory">
                        <div *ngFor="let decision of review.reportDecision | slice:1; last as isLast" class="mb-3">
                          <hr class="orange-border">

                          <div>
                            <p class="font-14 grey-color">{{'reviews.Resolved by' | translate}}</p>
                            <div class="name-with-image thumb">
                              <div class="image-circle mr-2">
                                <span *ngIf="!decision.resolvedbyIcon">{{ decision.resolvedbyName | shortName }}</span>
                                <img *ngIf="decision.resolvedbyIcon" [src]="decision.resolvedbyIcon" (error)="decision.resolvedbyIcon = ''">
                              </div>
                              <div class="name">
                                <p class="font-16 fontMedium text-color">{{decision.resolvedbyName}}</p>
                              </div>
                            </div>
                          </div>

                          <hr>

                          <div>
                            <p class="font-14 grey-color">{{'reviews.Resolution' | translate}}</p>
                            <p class="font-16 fontMedium text-color">{{decision.resolution}}</p>
                          </div>

                          <hr>

                          <div>
                            <p class="font-14 grey-color">{{'reviews.Resolved on' | translate}}</p>
                            <p class="font-16 fontMedium text-color">
                              <!-- {{review.reportDecision.resolvedDate | date}} -->
                              {{decision.resolvedDate | date:'d MMM, y'}} {{'guests.at' | translate }} {{decision.resolvedDate | date:'shortTime'}}
                            </p>
                          </div>

                          <hr>

                          <div>
                            <p class="font-14 grey-color">{{'forms.Notes' | translate}}</p>
                            <p class="font-16 fontMedium text-color">{{decision.resolutionComment}}</p>
                          </div>

                          <!-- <hr class="orange-border" *ngIf="!isLast"> -->
                        </div>
                      </ng-container>
                    </div>
                  </div>

              </div>
              <!-- If Guests Reviews Component -->
              <!-- && (review.canEditDecision || review.canMakeDecision) -->
              <div class="sheet-actions" *ngIf="isReported">
                <div class="big">
                  <button mat-button color="primary"
                    (click)="openResolveForm()"
                    class="w-100 text-uppercase">
                    <span *ngIf="!review.reportDecision">{{'reviews.Mark As Resolved' | translate}}</span>
                    <span *ngIf="review.reportDecision">{{'reviews.Change Decision' | translate}}</span>
                  </button>
                </div>
              </div>
              <div class="sheet-actions" *ngIf="isGuestsReview">
                <div class="big">
                  <!-- If it's already Reported -->
                  <div class="d-flex align-items-center text-center justify-content-center mb-2"
                      *ngIf="review?.reportStatus == 'Reported'">
                      <p class="info font-14 fontMedium dark-grey-color">
                          {{'reviews.This Review has been reported by a user. Please go to the Reported content screen to take action' | translate}}
                      </p>
                  </div>
                  <button mat-button class="w-100 text-uppercase grey-background"
                    [disabled]="btnLoading || review.reportStatus == 'Reported'"
                      [class.loading]="btnLoading" (click)="HideReview(review.isHide)">
                      <span *ngIf="!review?.isHide">
                          <i class="fa fa-eye-slash red-color mr-2" aria-hidden="true"></i>
                          {{'reviews.Hide Review' | translate}}
                      </span>
                      <span *ngIf="review?.isHide">
                          <i class="fa fa-eye red-color mr-2" aria-hidden="true"></i>
                          {{'reviews.UnHide Review' | translate}}
                      </span>
                  </button>
                </div>
              </div>
          </ng-container>

      </div>
  </div>

</div>


<!-- NotReported, Reported, Resolved -->
